import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { defineAsyncComponent } from 'vue';
import { useSystemConfigurationShortcut } from '@/composables/useSystemConfigurationShortcut';

// Only system administrators ever open it, so the overlay and its pages stay out of everyone else's bundle.

export default /*@__PURE__*/_defineComponent({
  __name: 'SystemConfiguration',
  setup(__props) {

const SystemConfigurationOverlay = defineAsyncComponent(() => import('@/components/layouts/dashboardLayout/systemConfiguration/SystemConfigurationOverlay.vue'));
const { isOpen, close } = useSystemConfigurationShortcut();

return (_ctx: any,_cache: any) => {
  return (_unref(isOpen))
    ? (_openBlock(), _createBlock(_unref(SystemConfigurationOverlay), {
        key: 0,
        onClose: _unref(close)
      }, null, 8, ["onClose"]))
    : _createCommentVNode("", true)
}
}

})